import Button from 'src/Components/Button/Button';
import './NoLicenseActivated.css'
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { InfoMessageType } from 'src/Components/InfoBar/InfoBar';
import LicensePayment from '../Payment/LicensePayment';
import { useGetPaymentProducts } from 'src/Utils/Hooks/Payments/useGetPaymentProducts';
import { AuraSuiteIcon } from 'src/SharedComponents/Icons/Icons';

type INoLicenseActivated = {
    clinicId: string;
    updatePageLoader: (load: boolean) => void;
    setInfo: (message: string, type: InfoMessageType) => void;
    showPaymentOption: boolean;
}
const NoLicenseActivated: React.FC<INoLicenseActivated> = ({clinicId, updatePageLoader, setInfo, showPaymentOption }) => {
    const { t } = useTranslation();
    const [showLicensePaymentDialog, setShowLicensePaymentDialog] = useState<boolean>(false);
    const {products, reqestError, reqestLoading, getPaymentProducts} = useGetPaymentProducts();

    useEffect(() => {
        updatePageLoader(reqestLoading) 
    }, [reqestLoading, updatePageLoader]);

    useEffect(() => {
        if (reqestError !== '') {
            setInfo(reqestError, InfoMessageType.error);
        } 
    },[reqestError, setInfo]);
    
    useEffect(() => {
        if(showPaymentOption) {
             getPaymentProducts(clinicId);
        }
    }, [getPaymentProducts, clinicId, showPaymentOption]);

    const isButtonDisabled = useMemo(() => {
        return !products?.suiteProductComboInfos?.length;
    }, [products]);

    return (
        <>
            {
                showLicensePaymentDialog && 
                products &&
                    <LicensePayment
                       clinicId={clinicId}
                       products={products}
                       updatePageLoader={updatePageLoader}
                        onClose={()=>{setShowLicensePaymentDialog(false)}}
                        setInfo={setInfo}
                    />
            }
            {   showPaymentOption &&
                <div className='noLicenseContainer noLicensePurchase'>
                    <div className='noLicenseTitle'>{t('ThankYouForAura')}</div>
                    <div className='noLicenseSuiteRow'>
                        <AuraSuiteIcon size={32} />
                        <span className='noLicenseBody'>
                            <Trans i18nKey="AuraPurchase"/>
                        </span>
                    </div>
                    <div className='noLicenseOwnerNote'>
                        <p className='noLicenseBody'>{t('OnlyOwnersCanManageSubscription')}</p>
                        <p className='noLicenseBody'>
                            <Trans
                                i18nKey="ModifyUserPermissions"
                                components={{ usersLink: <Link to="/users" className='noLicenseLink' /> }}
                            />
                        </p>
                    </div>
                    <div>
                        <Button
                            text={t('DiscoverAuraSuites')}
                            fontSize='16px'
                            fontWeight='500'
                            onClick={() => setShowLicensePaymentDialog(true)}
                            disable={isButtonDisabled}
                        />
                    </div>
                </div>
            }
            {
                !showPaymentOption &&        
                <div className='noLicenseContainer'>
                    <div className="row">
                        <span style={{fontSize: '20px', fontWeight: 500, color: 'var(--color-primary)'}}>{t('NoLicensesAssigned')}</span>
                    </div>
                    <div className="row mt-4">
                        <span>{t('NeedAuraLicenseToUse')}</span>
                        <span>{t('ContactYourDistributor')}</span>
                    </div>
                    <div className="row mt-4">
                        <span>{t('DownloadAuraAppInstruction')}</span>
                    </div>
                </div>
            }
        </>
    )
}
export default NoLicenseActivated